import { useId } from "react";

import { ICONS } from "../../icons/icons";
import type { IconShape } from "../../icons/icons";
import type { IconProps, IconViewModel } from "./types-icon";

/** ViewModel do Icon: forma do ícone, acessibilidade (`role`, `aria-*`, `id` do título) e separação das props nomeadas; sem JSX. */
export function useIcon({
  name,
  size = 14,
  title,
  decorative: _decorative,
  className,
  style,
  testId,
  ...rest
}: IconProps): IconViewModel {
  const titleId = useId();
  const shape: IconShape = ICONS[name];

  return {
    ...shape,
    name,
    size,
    title,
    titleId,
    role: title ? "img" : undefined,
    ariaLabelledBy: title ? titleId : undefined,
    ariaHidden: title ? undefined : true,
    testId,
    className,
    style,
    rest,
  };
}
